<template>
    <div class="target-detail">
        <Paper class="target-detail-paper">
            <el-tabs class="target-list-tab-pane" v-model="activeTabs">
                <el-tab-pane label="目标明细" name="theList" ref="myPane">
                    <el-tabs v-model="tabsActiveName" @tab-click="handleTabClick" type="card">
                        <el-tab-pane
                            v-for="item in tabList"
                            :key="item.key"
                            :label="item.value"
                            :name="item.key"
                        ></el-tab-pane>
                    </el-tabs>

                    <list-layout-paper>
                        <!-- 表格 -->
                        <template v-slot:list="{ tableHeight }">
                            <edit-table-box
                                ref="editTableBox"
                                key="submissionApplicationTargetDetail"
                                v-loading="tableList.tableLoading"
                                :index="config.index"
                                :selection="config.selection"
                                :columns="config.columns"
                                height="500px"
                                :tableData="tableList.totalData"
                                :actions="config.actions"
                                :control="true"
                                :allowRowClick="false"
                                @btn-event="handleActive"
                            >
                            </edit-table-box>

                            <el-popover
                                placement="top-start"
                                width="400"
                                trigger="hover">
                                <ul class="goal-main-collect">
                                    <li v-for="item in goalMainCollect" :key="item.name">
                                        {{ item.name }}：<span>{{ item.value }}</span>
                                    </li>
                                    <li v-if="!goalMainCollect.length">暂无数据</li>
                                </ul>
                                <el-button  type="text" class="totalBox" slot="reference">汇总</el-button>
                            </el-popover>
                        </template>
                        <template slot="footer">
                            <lots-pagination
                                @size-change="tableList.sizeChange"
                                :current-page.sync="tableList.pageNo"
                                @current-change="tableList.pageChange"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="tableList.pageTotal" >
                            </lots-pagination>
                        </template>
                    </list-layout-paper>
                </el-tab-pane>
            </el-tabs>
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, watch } from '@vue/composition-api';
import { Message, MessageBox } from 'element-ui';
import { handleDictionaryDataString, formatDictCodeToName } from '@/modules/mdm/utils.js';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import editTableBox from '@/components/lots/editTableBox/Index';
import { getGoalInfoList, deleteApi, getGoalMainCollect } from '@/modules/mdm/api/targetModdeules/subMissionApplication.js';
import _ from 'lodash';

export default {
    name: 'targetObj',
    components: {
        Paper,
        listLayoutPaper,
        editTableBox,
        lotsPagination
    },
    props: {
        data: {
            type: Object,
            default() {
                return {};
            }
        },
        goalTypeOptions: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const config = reactive({});
        // 目标明细tab
        const activeTabs = ref('theList');
        // 目标明细tab的activeName
        const tabsActiveName = ref('');
        // 目标明细tab的列表
        const tabList = ref(props.goalTypeOptions || []);
        // 目标明细tab的默认activeName
        if (tabList.value.length > 0) {
            tabsActiveName.value = tabList.value[0].key;
        }
        const applyData = ref(props.data || {});
        // 添加对props.data的监听
        watch(
            () => props.data,
            (newData) => {
                applyData.value = newData;
            },
            { deep: true } // 深度监听，确保对象内部属性变化也能被捕获
        );

        const searchDataFormat = (condition) => {
            condition.applyCode = applyData.value.applyCode;
            condition.groupId = groupId.value;
            condition.groupName = groupName.value;
            condition.goalTypeCode = tabsActiveName.value;
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return condition;
        };

        const option = {
            name: 'submissionApplicationTargetDetail',
            selection: false,
            index: false,
            columns: [],
            actions: {
                fixedWidth: 60,
                list: [
                    {
                        label: '删除',
                        event: 'delete',
                        displayRule: (row) => {
                            // 按钮显示：审批状态=草稿/驳回/撤回
                            if ([1, 5, 6].includes(+row.approvalStatus)) {
                                return true;
                            }
                        }
                    }
                ]
            }
        };

        class ListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    // 目标明细表头数据
                    if (res.data.goalDetailColumnList && res.data.goalDetailColumnList.length) {
                        const opt = _.cloneDeep(option);
                        opt.columns = res.data.goalDetailColumnList.map(v => {
                            return {
                                ...v,
                                width: 100
                            };
                        });
                        Object.assign(config, opt);
                    } else {
                        const opt = _.cloneDeep(option);
                        opt.columns.push({ prop: 'null', label: '暂无表头数据' });
                        Object.assign(config, opt);
                    }
                    // 目标明细数据
                    if (res.data.goalDetailColumnList && res.data.goalDetailColumnList.length) {
                        this.totalData.value = res.data.goalDetailDataList.map(v => {
                            return {
                                ...v,
                                approvalStatus: applyData.value.approvalStatus
                            };
                        });
                    } else {
                        this.totalData.value = [];
                    }
                    // 目标明细分页数据
                    this.pageTotal.value = res.data.count;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }

        const tableList = new ListClass({
            Api: {
                listApi: getGoalInfoList // 查询接口
            }
        });

        // 操作项
        const handleActive = (row, event) => {
            // 删除
            if (event === 'delete') {
                deleteOpera(row);
            }
        };

        const handleTabClick = (tab) => {
            tabsActiveName.value = tab.name;
            if (applyData.value.applyCode) {
                tableList.getList();
                getGoalMainCollectData();
            }
        };

        // 删除操作
        const deleteOpera = (row) => {
            MessageBox.confirm('此操作将删除对应数据,是否继续？', '温馨提示', {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                tableList.tableLoading.value = true;
                const params = {
                    applyCode: applyData.value.applyCode,
                    respUserNameSet: row.respUserName,
                    groupId: groupId.value,
                    groupName: groupName.value
                };
                deleteApi(params).then(res => {
                    if (+res.code === 0) {
                        Message.success('删除成功');
                        setupContext.emit('deleteSuccessHandle');
                    }
                }).finally(() => {
                    tableList.tableLoading.value = false;
                });
            });
        };

        const groupId = ref('');
        const groupName = ref('');
        // 提供给组件外面调用的刷新方法
        const refreshList = (name, id) => {
            groupName.value = name;
            groupId.value = id;
            tableList.getList();
            getGoalMainCollectData();
        };

        const goalMainCollect = ref([]);
        const getGoalMainCollectData = () => {
            const params = {
                goalTypeCode: tabsActiveName.value,
                groupId: groupId.value,
                groupName: groupName.value,
                applyCode: applyData.value.applyCode
            };
            goalMainCollect.value = [];
            getGoalMainCollect(params).then(res => {
                if (+res.code === 0) {
                    if (res.data.dynamiColumnCollectMap) {
                        const list = [];
                        const obj = res.data.dynamiColumnCollectMap;
                        for (const key of Object.keys(obj)) {
                            list.push({
                                name: key,
                                value: obj[key]
                            });
                        }
                        goalMainCollect.value = list;
                    }
                }
            });
        };

        return {
            tableList,
            config,
            formatDictCodeToName,
            handleDictionaryDataString,
            handleActive,
            activeTabs,
            tabList,
            tabsActiveName,
            applyData,
            handleTabClick,
            refreshList,
            goalMainCollect
        };
    }
};
</script>

<style lang="less" >
    .list-dropdown.el-dropdown {
        color: #fff;
    }

    .list-dropdown-menu {
        background-color: #fff;
    }

    .target-detail {
    width: 100%;

    .target-detail-paper {
        height: 100%;
    }

    .list-layout-wrapper {
        height: 100%;
    }

    .target-list-tab-pane {
        .el-tabs__item {
            height: 32px;
            line-height: 32px;
        }
    }

    .target-list-tab-pane.el-tabs {
        width: 100%;
        height: 100%;

        &>.el-tabs__content {
            height: calc(100% - 40px - 14px);
            overflow: auto;

            &>.el-tab-pane {
                overflow: auto;
                padding-right: 5px;
                height: 100%;

                .list-main {
                    .table-box {
                        height: 100%;
                    }
                }
            }
        }
    }

    .flex-layout .list-main {
        overflow: auto;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .list-header {
        padding: 0;
        margin-bottom: 0;
        .target-detail-list-dropdown.el-dropdown {
            color: #fff;
        }
    }

    .layout-content {
        min-width: auto;
    }

    .layout-content.target-detail-paper {
        padding: 0px;

        .el-table .cell.el-tooltip {
            &>div {
                width: 100%;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    }

    .list-layout-wrapper {
        padding: 0px;
    }
}

.target-detail-list-dropdown-menu {
    background-color: #fff;
}

.column-config_title {
    font-size: 14px;
}

.totalBox {
    position: absolute;
    left: 10px;
    bottom: 10px;
    z-index: 2;
}

.goal-main-collect {
    max-height: 200px;
    overflow: auto;
    li {
        font-size: 14px;
        padding: 5px 0;

        span {
            font-weight: bold;
            color: #4285f5;
        }
    }
}
</style>
